export const TRANSLATIONS = {
  fr: {
    appName: "cordialement.ai",
    // Hero
    heroKicker: "Boîte à outils de survie corporate",
    heroTitleLine1: "Écris ce que tu penses.",
    heroTitleLine2: "Envoie autre chose.",
    heroSub:
      "Reformule, décode, mesure — la trousse de secours du Télétravailleur face au corporate.",
    dossierRef: "Dossier n° CDLT-2026",
    // Counter
    counterHeadline: "incidents RH évités",
    counterSub: "depuis le dernier point d'équipe",
    // Top-level modes (V2)
    sectionTopModeLabel: "Section 01 · Nature du dossier",
    topModes: {
      cordialement: {
        label: "Cordialement",
        sub: "Ce que je pense → ce que je peux envoyer",
      },
      reverse: {
        label: "Reverse",
        sub: "Ce que je peux envoyer → ce que j'aurais préféré écrire",
      },
      antidote: {
        label: "Antidote",
        sub: "Le corporate traduit en français humain",
      },
      bullshit: {
        label: "Bullshit Score",
        sub: "Mesure le taux de jargon d'un message",
      },
    },
    // Sub-mode (only inside CORDIALEMENT)
    sectionModeLabel: "Section 01.b · Nature de la requête",
    modeReformulate: "Reformuler",
    modeReformulateDesc: "J'ai un truc à dire (en mode brut) → version civilisée",
    modeReply: "Répondre",
    modeReplyDesc: "J'ai reçu un message agaçant → réponse pro",
    // Tone
    toneLabel: "Section 02 · Niveau de contention émotionnelle",
    tones: {
      diplomatic: "Diplomatique",
      professional: "Professionnel",
      assertive: "Assertif",
      humor: "Humour subtil",
      passive_aggressive: "Passif-agressif élégant",
    },
    // Diplomacy slider
    diplomacyLabel: "Curseur de diplomatie",
    diplomacyHint: "0 = je dis tout · 100 = ONU",
    diplomacySteps: {
      assume: "On assume",
      direct: "Direct",
      professional: "Professionnel",
      diplomatic: "Diplomatique",
      un: "Secrétaire ONU",
    },
    // Reverse intensity
    reverseIntensityLabel: "Section 02 · Niveau de franchise",
    reverseIntensities: {
      franc: "Franc",
      suffit: "Ça commence à suffire",
      nuclear: "Bien cordialement dans ta gueule",
    },
    reverseCta: "Dé-cordialiser",
    reverseResultLabel: "Version pensée intérieure",
    reversePlaceholder: "Colle le message professionnel ici, on te dit ce qu'il donne sans le vernis…",
    // Antidote UX
    antidoteCta: "Décoder",
    antidoteResultLabel: "Décodage administratif",
    antidotePlaceholder: "Colle l'email corporate que tu ne comprends pas…",
    antidoteSections: {
      plain: "En clair",
      ask: "Ce qu'on te demande",
      deadline: "Pour quand",
      jargon: "Jargon détecté",
    },
    antidoteNoDeadline: "Pas précisé.",
    antidoteNoJargon: "Aucun jargon manifeste.",
    // Bullshit score
    bullshitCta: "Diagnostiquer",
    bullshitResultLabel: "Diagnostic",
    bullshitPlaceholder: "Colle le message pour analyse. On mesure le taux de bullshit corporate.",
    bullshitScoreLabel: "Bullshit Score",
    bullshitScoreSub: "Diagnostic non homologué ISO 0000.",
    bullshitSections: {
      terms: "Jargon détecté",
      plain: "En français",
      short: "Ce qu'il fallait écrire",
      diagnosis: "Diagnostic",
    },
    // Input / Output
    sectionInputLabel: "Section 03 · Rédaction",
    inputLabelReformulate: "Message initial",
    inputLabelReply: "Message reçu (pièce jointe)",
    inputLabelReverse: "Message corporate à retourner",
    inputLabelAntidote: "Email corporate reçu",
    inputLabelBullshit: "Message à analyser",
    inputPlaceholderReformulate:
      "Ex : Marc, arrête de me CC sur tes mails inutiles, j'en peux plus...",
    inputPlaceholderReply:
      "Ex : 'Comme convenu lors de notre échange de la semaine dernière, je rappelle que...'",
    outputLabel: "Version envoyable",
    outputStatus: "Statut : envoyable sans convocation RH",
    outputEmpty: "La version civilisée s'affichera ici. Respire un coup.",
    reverseOutputEmpty: "La traduction non contractuelle apparaîtra ici. Souffle un coup.",
    antidoteOutputEmpty: "Le décodage apparaîtra ici. Prépare-toi à comprendre.",
    bullshitOutputEmpty: "Le diagnostic apparaîtra ici. Aucun cadre n'a été blessé.",
    generate: "Civiliser",
    generating: "Traitement administratif en cours…",
    copy: "Copier",
    copied: "Copié",
    again: "Régénérer",
    history: "Archives",
    historyEmpty: "Aucune pièce archivée. Ouvre ton premier dossier.",
    clearHistory: "Purger les archives",
    historyLocalNotice:
      "🔒 Archives 100% locales dans ton navigateur (localStorage). Rien n'est envoyé ni stocké sur nos serveurs. « Purger » efface définitivement.",
    inputRequired: "Rédige d'abord le message.",
    error: "Une erreur administrative est survenue. Réessaie.",
    parseError: "Le service IA a bafouillé. Régénère.",
    // Footer
    footerTagline: "La haine, mais en mieux.",
    langToggle: "EN",
    // Chars
    charsLabel: "caractères",
    // Privacy banner
    privacyStrong: "Zéro compte, zéro cookie, zéro donnée stockée.",
    privacySoft: "Ton message est reformulé à la volée puis oublié.",
    // Legacy keys kept for backward-compat
    tagline: "Écris ce que tu penses. Envoie autre chose.",
    output: "Version envoyable",
    counterSuffix: "incidents RH évités",
    footer: "Civiliser sans pardonner.",
    new: "Nouveau",
  },
  en: {
    appName: "cordialement.ai",
    heroKicker: "Corporate survival toolkit",
    heroTitleLine1: "Write what you think.",
    heroTitleLine2: "Send something else.",
    heroSub:
      "Rewrite, decode, measure — the field kit for surviving corporate messaging.",
    dossierRef: "File no. CDLT-2026",
    counterHeadline: "HR incidents avoided",
    counterSub: "since the last team meeting",
    sectionTopModeLabel: "Section 01 · Case type",
    topModes: {
      cordialement: {
        label: "Cordialement",
        sub: "What I think → what I can send",
      },
      reverse: {
        label: "Reverse",
        sub: "What I can send → what I wish I'd written",
      },
      antidote: {
        label: "Antidote",
        sub: "Corporate translated into plain English",
      },
      bullshit: {
        label: "Bullshit Score",
        sub: "Measure the jargon density of a message",
      },
    },
    sectionModeLabel: "Section 01.b · Request type",
    modeReformulate: "Rephrase",
    modeReformulateDesc: "Something raw to say → civilized version",
    modeReply: "Reply",
    modeReplyDesc: "I got an annoying message → pro response",
    toneLabel: "Section 02 · Emotional restraint level",
    tones: {
      diplomatic: "Diplomatic",
      professional: "Professional",
      assertive: "Assertive",
      humor: "Subtle humor",
      passive_aggressive: "Elegant passive-aggressive",
    },
    diplomacyLabel: "Diplomacy slider",
    diplomacyHint: "0 = no filter · 100 = UN",
    diplomacySteps: {
      assume: "No filter",
      direct: "Direct",
      professional: "Professional",
      diplomatic: "Diplomatic",
      un: "UN Secretary",
    },
    reverseIntensityLabel: "Section 02 · Bluntness",
    reverseIntensities: {
      franc: "Frank",
      suffit: "I've had enough",
      nuclear: "Politely furious",
    },
    reverseCta: "De-cordialize",
    reverseResultLabel: "Inner-thought version",
    reversePlaceholder: "Paste the corporate message here — we'll strip the polish…",
    antidoteCta: "Decode",
    antidoteResultLabel: "Administrative decoding",
    antidotePlaceholder: "Paste the corporate email you can't parse…",
    antidoteSections: {
      plain: "In plain English",
      ask: "What they want",
      deadline: "By when",
      jargon: "Jargon detected",
    },
    antidoteNoDeadline: "Not specified.",
    antidoteNoJargon: "No obvious jargon.",
    bullshitCta: "Diagnose",
    bullshitResultLabel: "Diagnostic",
    bullshitPlaceholder: "Paste the message. We'll measure the corporate BS density.",
    bullshitScoreLabel: "Bullshit Score",
    bullshitScoreSub: "Diagnostic not ISO 0000 certified.",
    bullshitSections: {
      terms: "Jargon detected",
      plain: "In plain English",
      short: "What they should have written",
      diagnosis: "Diagnostic",
    },
    sectionInputLabel: "Section 03 · Drafting",
    inputLabelReformulate: "Initial message",
    inputLabelReply: "Received message (attachment)",
    inputLabelReverse: "Corporate message to flip",
    inputLabelAntidote: "Corporate email received",
    inputLabelBullshit: "Message to analyze",
    inputPlaceholderReformulate:
      "E.g. Mark, stop CC'ing me on useless emails, I can't take it anymore...",
    inputPlaceholderReply:
      "E.g. 'As discussed last week, I'd like to remind you that...'",
    outputLabel: "Sendable version",
    outputStatus: "Status: sendable without HR summons",
    outputEmpty: "The civilized version will appear here. Take a breath.",
    reverseOutputEmpty: "The non-binding translation will appear here. Breathe.",
    antidoteOutputEmpty: "The decoding will appear here. Prepare to understand.",
    bullshitOutputEmpty: "The diagnostic will appear here. No manager was harmed.",
    generate: "Civilize",
    generating: "Processing paperwork…",
    copy: "Copy",
    copied: "Copied",
    again: "Regenerate",
    history: "Archives",
    historyEmpty: "No archived file. Open your first case.",
    clearHistory: "Purge archives",
    historyLocalNotice:
      "🔒 Archives are 100% local in your browser (localStorage). Nothing is sent to or stored on our servers. \"Purge\" wipes it permanently.",
    inputRequired: "Write the message first.",
    error: "An administrative error occurred. Try again.",
    parseError: "The AI service stuttered. Regenerate.",
    footerTagline: "Hate, but better.",
    langToggle: "FR",
    charsLabel: "characters",
    privacyStrong: "No account, no cookies, no data stored.",
    privacySoft: "Your message is rephrased on the fly, then forgotten.",
    tagline: "Write what you think. Send something else.",
    output: "Sendable version",
    counterSuffix: "HR incidents avoided",
    footer: "Civilize without forgiving.",
    new: "New",
  },
};

export const TONE_COLORS = {
  diplomatic: "#B5EAD7",
  professional: "#C7CEEA",
  assertive: "#FFDAC1",
  humor: "#FFF2B2",
  passive_aggressive: "#E2F0CB",
};

export const TONE_ORDER = [
  "diplomatic",
  "professional",
  "assertive",
  "humor",
  "passive_aggressive",
];

export const TONE_LEVEL = {
  diplomatic: "N1",
  professional: "N2",
  assertive: "N3",
  humor: "N4",
  passive_aggressive: "N5",
};

// V2 palette per top mode — also re-exported from constants/diplomate.js
export const TOP_MODE_COLORS = {
  cordialement: "#B5EAD7",
  reverse: "#FFDAC1",
  antidote: "#C7CEEA",
  bullshit: "#FFF2B2",
};
